import { createZip } from './zipWriter';

function escapeXml(value) {
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
}

function columnLetter(index) {
    let n = index + 1;
    let letters = '';
    while (n > 0) {
        const rem = (n - 1) % 26;
        letters = String.fromCharCode(65 + rem) + letters;
        n = Math.floor((n - 1) / 26);
    }
    return letters;
}

function buildSheetXml(headers, rows) {
    const rowsXml = [];

    const headerCells = headers
        .map((h, c) => `<c r="${columnLetter(c)}1" t="inlineStr"><is><t>${escapeXml(h)}</t></is></c>`)
        .join('');
    rowsXml.push(`<row r="1">${headerCells}</row>`);

    rows.forEach((row, r) => {
        const rowNum = r + 2;
        const cells = headers
            .map((h, c) => {
                const value = row[h];
                const ref = `${columnLetter(c)}${rowNum}`;
                if (value === null || value === undefined || value === '') return '';
                if (typeof value === 'number' && Number.isFinite(value)) {
                    return `<c r="${ref}"><v>${value}</v></c>`;
                }
                return `<c r="${ref}" t="inlineStr"><is><t>${escapeXml(value)}</t></is></c>`;
            })
            .join('');
        rowsXml.push(`<row r="${rowNum}">${cells}</row>`);
    });

    return `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">
<sheetData>${rowsXml.join('')}</sheetData>
</worksheet>`;
}

const CONTENT_TYPES = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">
<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>
<Default Extension="xml" ContentType="application/xml"/>
<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>
<Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>
</Types>`;

const ROOT_RELS = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>
</Relationships>`;

const WORKBOOK_XML = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">
<sheets><sheet name="Sheet1" sheetId="1" r:id="rId1"/></sheets>
</workbook>`;

const WORKBOOK_RELS = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/>
</Relationships>`;

/**
 * Builds a genuine, minimal .xlsx file (no external library) and triggers a
 * download. `rows` is an array of plain objects; `headers` controls column
 * order — defaults to the keys of the first row.
 */
export function downloadXlsx(filename, rows, headers = null) {
    if (!rows || rows.length === 0) return;
    const cols = headers || Object.keys(rows[0]);
    const sheetXml = buildSheetXml(cols, rows);

    const zip = createZip([
        { name: '[Content_Types].xml', content: CONTENT_TYPES },
        { name: '_rels/.rels', content: ROOT_RELS },
        { name: 'xl/workbook.xml', content: WORKBOOK_XML },
        { name: 'xl/_rels/workbook.xml.rels', content: WORKBOOK_RELS },
        { name: 'xl/worksheets/sheet1.xml', content: sheetXml },
    ]);

    const url = URL.createObjectURL(zip);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
